<main class="container-fluid px-0 pb-3 pb-lg-5" *ngIf="chosenCategory">

  <div class="px-3 py-2 py-md-0 bg-darkest">
    <div class="container-lg">
      <div class="d-flex align-items-center justify-content-between">
        <h1 class="h3 fw-bold mb-0">{{ 'CATEGORIES.' + (chosenCategory.replace('-','') | uppercase) | translate}}</h1>
        <div class="category-icon-overlay">
          <img [src]="'assets/icons/'+ chosenCategory.replace('-','') + '_big.svg'" alt="category background image" width="100%">
        </div>
      </div>
    </div>
  </div>

  <div class="container-lg">
    <div class="px-0">
      <!-- Searchbar -->
      <app-searchbar [searchTerm]="searchTerm" (searchChange)="onSearchChange($event)"></app-searchbar>

      <div>
        <div class="d-flex justify-content-between">
          <!-- filter by provider -->
          <div class="d-flex align-items-center my-3">
            <ng-container *ngIf="providersInChosenCategory.length > 1; else onlyOneProvider">
              <span class="d-none d-sm-block mx-2 text-secondary">{{ 'HOME.FILTER_LABEL' | translate }}</span>
              <button class="btn btn-outline-secondary rounded-pill d-flex align-items-center" (click)="toggleProviderSelector()">
                <span class="me-2">{{'PROVIDERS.TITLE' | translate}}</span>
                <span *ngIf="numOfSelectedProviders" class="me-2 badge rounded-pill bg-primary">{{numOfSelectedProviders}}<span class="visually-hidden">selected</span></span>
                <app-svg-icon class="variable-svg-icon" [pathIdentifier]="'dropdown'"></app-svg-icon>
              </button>
            </ng-container>
            <ng-template #onlyOneProvider>
              <span *ngIf="providersInChosenCategory[0]" class="mx-2 text-secondary">{{ 'HOME.ONE_PROVIDER_LABEL' | translate }} {{providersInChosenCategory[0].name}}</span>
            </ng-template>
          </div>

          <!-- sort by -->
          <div class="d-flex align-items-center justify-content-end my-3 me-1 sort-by-dropdown">
            <span class="d-none d-sm-block mx-2 text-secondary">{{ 'HOME.SORT_LABEL' | translate }}</span>
            <div class="btn-group">
              <button type="button" class="btn btn-outline-secondary rounded-pill d-flex align-items-center" data-bs-toggle="dropdown" aria-expanded="false">
                <span class="me-2">{{ 'HOME.SORT_'+ selectedSorting | translate }}</span>
                <app-svg-icon class="variable-svg-icon" [pathIdentifier]="'sort'"></app-svg-icon>
              </button>
              <ul class="dropdown-menu">
                <li><button class="dropdown-item" type="button" (click)="sortOptionSelected('AZ')">{{ 'HOME.SORT_AZ' | translate }}</button></li>
                <li><button class="dropdown-item" type="button" (click)="sortOptionSelected('ZA')">{{ 'HOME.SORT_ZA' | translate }}</button></li>
                <li><button class="dropdown-item" type="button" (click)="sortOptionSelected('POPULAR')">{{ 'HOME.SORT_POPULAR' | translate }}</button></li>
                <li><button class="dropdown-item" type="button" (click)="sortOptionSelected('FEATURED')">{{ 'HOME.SORT_FEATURED' | translate }}</button></li>
              </ul>
            </div>
          </div>
        </div>

        <div class="provider-selector row justify-content-center g-2 flex-wrap" *ngIf="showProviderSelector">
          <ng-container *ngFor="let provider of providersInChosenCategory">
            <div class="provider-filter col-6 col-sm-4 col-md-3 col-lg-2">
              <input class="btn-check" type="checkbox" id="{{ provider.routerLink }}" [(ngModel)]="providerFilter[provider.routerLink]"
                     (change)="loadItems(undefined)">
              <label class="btn btn-outline-primary rounded-2 d-flex justify-content-center" for="{{ provider.routerLink}}" >
                <img class="img-fluid w-100" [src]="provider.imagePath" alt="{{provider.name}} logo" (error)="updateNotFoundImgUrl($event)">
              </label>
            </div>
          </ng-container>
        </div>


      </div>

    <!--  games -->
      <div *ngIf="filteredGames && filteredGames.length; else noMatchBlock " class="pt-3">
        <app-game-chunk [games]="displayedGames"></app-game-chunk>

        <!--  Load more or less games-->
        <app-item-showcase [totalItems]="filteredGames.length" [itemsPerPage]="itemsPerPage" [resetFlag]="resetBySortOrFilterNeeded" (itemsToLoad)="loadItems($event)" ></app-item-showcase>
      </div>

      <ng-template #noMatchBlock>
        <div class="container text-center pt-5">
          <ng-container *ngIf="!randomGamesForCarousel.length">
            <h3>{{'HOME.NOGAMES_MESSAGE' | translate}}</h3>
            <h4>{{'HOME.NOGAMES_TIP' | translate}}</h4>
          </ng-container>
          <ng-container *ngIf="randomGamesForCarousel.length">
            <h3>{{'HOME.NOMATCH_MESSAGE' | translate}}</h3>
            <h4 *ngIf="searchTerm.length">{{'HOME.NOMATCH_TIP' | translate}}</h4>
          </ng-container>
        </div>
      </ng-template>


      <div class="mt-4">
        <app-providers-carousel></app-providers-carousel>
        <app-carousel [dataList]="randomGamesForCarousel" [identifier]="'all'"></app-carousel>
      </div>

    </div>
  </div>

</main>


